import { j as e } from "./atoms-v218.js";
import { forwardRef as p, useRef as c, useImperativeHandle as u } from "react";
import { CalendarTableRow as i } from "./atoms-v21169.js";
import { CalendarTableHeaderCell as b } from "./atoms-v21170.js";
import { Table as f, TableHeadRow as x } from "./atoms-v21171.js";
import { useCalendarContext as j } from "./atoms-v2766.js";
function T({ colorTheme: n = "light", isLoading: t, monthConfig: l }, m) {
  const { domBuilder: d } = j(), o = c({});
  return u(
    m,
    () => ({
      get calendarTableRowAPIMap() {
        return o.current;
      }
    })
  ), /* @__PURE__ */ e.jsxs(f, { children: [
    /* @__PURE__ */ e.jsx("thead", { children: /* @__PURE__ */ e.jsx(x, { children: d.text.weekdays.map((a, r) => /* @__PURE__ */ e.jsx(b, { isLoading: t, label: a }, r)) }) }),
    /* @__PURE__ */ e.jsx("tbody", { children: l.weeks.map((a, r) => /* @__PURE__ */ e.jsx(
      i,
      {
        colorTheme: n,
        isLoading: t,
        month: l.value,
        ref: (s) => o.current[r] = s,
        weekRowConfig: a,
        weekRowConfigIdx: r
      },
      r
    )) })
  ] });
}
const y = p(T);
export {
  y as CalendarTable,
  T as ComponentToForward
};
